module.exports = __webpack_public_path__ + "media/components/shared/static/video-0d13b1bef3b0e808ba481de2a1b6a502.svg";